import {
  GET_CONVERSION_FUNNEL_REPORT,
  GET_REPORT_CPNAME_LIST,
  GET_REPORT_EMPLOYEE_LIST,
  GET_REPORT_PROPERTY_LIST,
  GET_TEAM_CP_PERFORMANCE_REPORT,
  GET_TEAM_PERFORMANCE_REPORT,
  MONTHLY_PROPERTY_REPORT,
  USER_ACTIVITY_REPORT,
  GET_PDR_REPORT,
  GET_ST_REPORT,
  GET_CT_REPORT,
  GET_CM_REPORT,
  GET_SM_LIST,
  GET_SM_REPORT,
  GET_SCM_REPORT,
  GET_SHCH_REPORT,
  GET_SITE_LEAD_VISIT,
  GET_SRCH_REPORT,
  GET_BM_REPORT
} from "../types";

const initialState = {
  response: null,
  teamResponse: null,
  reportPropertyList: null,
  reportEmployeeList: null,
  reportCPNAMEList: null,
  teamCpResponse: null,
  monthlyPropertyReport: null,
  userActivityReport: null,
  pdrReport:null,
  roleReport:null,
  loading: true,
  create: false,
  detail: false,
};

export default function reportDataStore(state = initialState, action) {
  switch (action.type) {
    case GET_CONVERSION_FUNNEL_REPORT:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };
    case GET_TEAM_PERFORMANCE_REPORT:
      return {
        ...state,
        create: false,
        detail: false,
        teamResponse: action.payload,
      };
    case GET_TEAM_CP_PERFORMANCE_REPORT:
      return {
        ...state,
        create: false,
        detail: false,
        teamCpResponse: action.payload,
      };
    case GET_REPORT_PROPERTY_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        reportPropertyList: action.payload,
      };
    case GET_REPORT_EMPLOYEE_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        reportEmployeeList: action.payload,
      };
    case GET_REPORT_CPNAME_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        reportCPNAMEList: action.payload,
      };
    case MONTHLY_PROPERTY_REPORT:
      return {
        ...state,
        create: false,
        detail: false,
        monthlyPropertyReport: action.payload,
      };
    case USER_ACTIVITY_REPORT:
      return {
        ...state,
        create: false,
        detail: false,
        userActivityReport: action.payload,
      };
      case GET_PDR_REPORT:
        return {
          ...state,
          create: false,
          detail: false,
          pdrReport: action.payload,
        };
        case GET_ST_REPORT:
        return {
          ...state,
          create: false,
          detail: false,
          roleReport: action.payload,
        };
        case GET_CT_REPORT:
        return {
          ...state,
          create: false,
          detail: false,
          roleReport: action.payload,
        };
        case GET_CM_REPORT:
        return {
          ...state,
          create: false,
          detail: false,
          roleReport: action.payload,
        };
        case GET_SM_REPORT:
        return {
          ...state,
          create: false,
          detail: false,
          roleReport: action.payload,
        };
        case GET_SCM_REPORT:
        return {
          ...state,
          create: false,
          detail: false,
          roleReport: action.payload,
        };
        case GET_SHCH_REPORT:
        return {
          ...state,
          create: false,
          detail: false,
          roleReport: action.payload,
        };
        case GET_SRCH_REPORT:
        return {
          ...state,
          create: false,
          detail: false,
          roleReport: action.payload,
        };
        case GET_BM_REPORT:
        return {
          ...state,
          create: false,
          detail: false,
          roleReport: action.payload,
        };
    default:
      return state;
  }
}
